var moduleMap = {
	"./constants": () => {
		return __webpack_require__.e(5902).then(() => (() => ((__webpack_require__(65902)))));
	},
	"./types": () => {
		return __webpack_require__.e(2292).then(() => (() => ((__webpack_require__(52292)))));
	},
	"./utils": () => {
		return Promise.all([__webpack_require__.e(2263), __webpack_require__.e(7359), __webpack_require__.e(4762), __webpack_require__.e(8520), __webpack_require__.e(8454), __webpack_require__.e(7830), __webpack_require__.e(1986)]).then(() => (() => ((__webpack_require__(91986)))));
	},
	"./hooks": () => {
		return Promise.all([__webpack_require__.e(4816), __webpack_require__.e(8397), __webpack_require__.e(2263), __webpack_require__.e(5011), __webpack_require__.e(7359), __webpack_require__.e(4762), __webpack_require__.e(4582), __webpack_require__.e(8060), __webpack_require__.e(8520), __webpack_require__.e(8454), __webpack_require__.e(482), __webpack_require__.e(5579), __webpack_require__.e(8048), __webpack_require__.e(1295), __webpack_require__.e(2567), __webpack_require__.e(7611), __webpack_require__.e(3457), __webpack_require__.e(8845), __webpack_require__.e(280), __webpack_require__.e(7830), __webpack_require__.e(3036)]).then(() => (() => ((__webpack_require__(3036)))));
	},
	"./Bootstrap": () => {
		return Promise.all([__webpack_require__.e(4816), __webpack_require__.e(8397), __webpack_require__.e(2263), __webpack_require__.e(9304), __webpack_require__.e(5011), __webpack_require__.e(41), __webpack_require__.e(5532), __webpack_require__.e(4726), __webpack_require__.e(7359), __webpack_require__.e(4762), __webpack_require__.e(4582), __webpack_require__.e(8060), __webpack_require__.e(8520), __webpack_require__.e(8454), __webpack_require__.e(482), __webpack_require__.e(5579), __webpack_require__.e(8048), __webpack_require__.e(1295), __webpack_require__.e(2567), __webpack_require__.e(7611), __webpack_require__.e(8845), __webpack_require__.e(5797)]).then(() => (() => ((__webpack_require__(27420)))));
	},
	"./router": () => {
		return Promise.all([__webpack_require__.e(5579), __webpack_require__.e(204)]).then(() => (() => ((__webpack_require__(204)))));
	},
	"./History": () => {
		return Promise.all([__webpack_require__.e(4816), __webpack_require__.e(4762), __webpack_require__.e(971)]).then(() => (() => ((__webpack_require__(80971)))));
	},
	"./Authorize": () => {
		return Promise.all([__webpack_require__.e(2263), __webpack_require__.e(4762), __webpack_require__.e(8520), __webpack_require__.e(8454), __webpack_require__.e(508)]).then(() => (() => ((__webpack_require__(50508)))));
	},
	"./isAuthorized": () => {
		return Promise.all([__webpack_require__.e(4762), __webpack_require__.e(1078)]).then(() => (() => ((__webpack_require__(71078)))));
	},
	"./UnAuthorized": () => {
		return Promise.all([__webpack_require__.e(4816), __webpack_require__.e(8397), __webpack_require__.e(9304), __webpack_require__.e(7359), __webpack_require__.e(4762), __webpack_require__.e(4582), __webpack_require__.e(8060), __webpack_require__.e(2947)]).then(() => (() => ((__webpack_require__(12947)))));
	},
	"./LandingPage": () => {
		return Promise.all([__webpack_require__.e(7359), __webpack_require__.e(4582), __webpack_require__.e(482), __webpack_require__.e(3337)]).then(() => (() => ((__webpack_require__(63337)))));
	},
	"./GameSelectorUtils": () => {
		return Promise.all([__webpack_require__.e(4816), __webpack_require__.e(4762), __webpack_require__.e(8048), __webpack_require__.e(1295), __webpack_require__.e(2567), __webpack_require__.e(7404)]).then(() => (() => ((__webpack_require__(57404)))));
	},
	"./ErrorBoundary": () => {
		return Promise.all([__webpack_require__.e(8397), __webpack_require__.e(9304), __webpack_require__.e(7359), __webpack_require__.e(4582), __webpack_require__.e(8060), __webpack_require__.e(482), __webpack_require__.e(8048), __webpack_require__.e(9097)]).then(() => (() => ((__webpack_require__(59097)))));
	},
	"./cWrapper": () => {
		return Promise.all([__webpack_require__.e(2263), __webpack_require__.e(7359), __webpack_require__.e(4762), __webpack_require__.e(8520), __webpack_require__.e(8454), __webpack_require__.e(1963)]).then(() => (() => ((__webpack_require__(51963)))));
	},
	"./Request": () => {
		return Promise.all([__webpack_require__.e(4762), __webpack_require__.e(1295), __webpack_require__.e(3457), __webpack_require__.e(8845), __webpack_require__.e(3409)]).then(() => (() => ((__webpack_require__(3409)))));
	},
	"./Link": () => {
		return Promise.all([__webpack_require__.e(4816), __webpack_require__.e(7359), __webpack_require__.e(4762), __webpack_require__.e(5579), __webpack_require__.e(6161), __webpack_require__.e(8659)]).then(() => (() => ((__webpack_require__(58659)))));
	},
	"./Selectors": () => {
		return Promise.all([__webpack_require__.e(2263), __webpack_require__.e(8520), __webpack_require__.e(3951)]).then(() => (() => ((__webpack_require__(73951)))));
	},
	"./Analytics": () => {
		return Promise.all([__webpack_require__.e(4306), __webpack_require__.e(3181)]).then(() => (() => ((__webpack_require__(93181)))));
	},
	"./NotFound": () => {
		return Promise.all([__webpack_require__.e(4816), __webpack_require__.e(8397), __webpack_require__.e(2263), __webpack_require__.e(9304), __webpack_require__.e(5011), __webpack_require__.e(5532), __webpack_require__.e(7359), __webpack_require__.e(4762), __webpack_require__.e(4582), __webpack_require__.e(8060), __webpack_require__.e(8520), __webpack_require__.e(8454), __webpack_require__.e(5579), __webpack_require__.e(8048), __webpack_require__.e(1295), __webpack_require__.e(2567), __webpack_require__.e(7611), __webpack_require__.e(194)]).then(() => (() => ((__webpack_require__(10194)))));
	},
	"./ViewOnlyAlert": () => {
		return Promise.all([__webpack_require__.e(8397), __webpack_require__.e(9304), __webpack_require__.e(7359), __webpack_require__.e(4582), __webpack_require__.e(8060), __webpack_require__.e(482), __webpack_require__.e(8288)]).then(() => (() => ((__webpack_require__(48288)))));
	},
	"./ViewOnlyTooltip": () => {
		return Promise.all([__webpack_require__.e(8397), __webpack_require__.e(9304), __webpack_require__.e(41), __webpack_require__.e(7359), __webpack_require__.e(4582), __webpack_require__.e(8060), __webpack_require__.e(867)]).then(() => (() => ((__webpack_require__(90867)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});